// ## Components
export var ACCORDION = 'SLDSAccordion';
export var ACCORDION_PANEL = 'SLDSAccordionPanel';
export var ALERT = 'SLDSAlert';
export var ALERT_CONTAINER = 'SLDSAlertContainer';
export var APP_LAUNCHER = 'SLDSAppLauncher';
export var APP_LAUNCHER_EXPANDABLE_SECTION = 'SLDSAppLauncherExpandableSection';
/* Remove at next breaking change */

export var APP_LAUNCHER_SECTION = 'SLDSAppLauncherSection';
export var APP_LAUNCHER_LINK = 'SLDSAppLauncherLink';
export var APP_LAUNCHER_TILE = 'SLDSAppLauncherTile';
export var APP_LAUNCHER_HEADER = 'SLDSAppLauncherHeader';
export var AVATAR = 'SLDSAvatar';
export var BADGE = 'SLDSBadge';
export var BRAND_BAND = 'SLDSBrandBand';
/* Remove at next breaking change */

export var BREAD_CRUMB = 'SLDSBreadcrumb';
export var BREADCRUMB = 'SLDSBreadcrumb';
export var BUILDER_HEADER = 'SLDSBuilderHeader';
export var BUILDER_HEADER_MISC = 'SLDSBuilderHeaderMisc';
export var BUILDER_HEADER_UTILITIES = 'SLDSBuilderHeaderUtilities';
export var BUILDER_HEADER_NAV = 'SLDSBuilderHeaderNav';
export var BUILDER_HEADER_NAV_DROPDOWN = 'SLDSBuilderHeaderNavDropdown';
export var BUILDER_HEADER_NAV_LINK = 'SLDSBuilderHeaderNavLink';
export var BUILDER_HEADER_TOOLBAR = 'SLDSBuilderHeaderToolbar';
export var BUTTON = 'SLDSButton';
export var BUTTON_GROUP = 'SLDSButtonGroup';
export var BUTTON_STATEFUL = 'SLDSButtonStateful';
export var BUTTON_ICON = 'SLDSButtonIcon'; // a non-interctive icon wrapper for SLDSUtilityIcon

export var CARD = 'SLDSCard';
export var CARD_BODY = 'SLDSCardBody';
export var CARD_EMPTY = 'SLDSCardEmpty';
export var CARD_FILTER = 'SLDSCardFilter';
export var CARD_FOOTER = 'SLDSCardFooter';
export var CARD_HEADER = 'SLDSCardHeader';
export var CAROUSEL = 'SLDSCarousel';
export var CAROUSEL_INDICATORS = 'SLDSCarouselIndicators';
export var CAROUSEL_ITEM = 'SLDSCarouselItem';
export var CAROUSEL_NAVIGATORS = 'SLDSCarouselNavigators';
export var CAROUSEL_AUTOPLAY_BUTTON = 'SLDSCarouselAutoplayButton';
export var COLOR_PICKER = 'SLDSColorPicker';
export var COMBOBOX = 'SLDSCombobox';
export var DATA_TABLE = 'SLDSDataTable';
export var DATA_TABLE_CELL = 'SLDSDataTableCell';
export var DATA_TABLE_COLUMN = 'SLDSDataTableColumn';
export var DATA_TABLE_HEAD = 'SLDSDataTableHead';
export var DATA_TABLE_HEADER_CELL = 'SLDSDataTableHeaderCell';
export var DATA_TABLE_ROW_ACTIONS = 'SLDSDataTableRowActions';
export var DATA_TABLE_ROW = 'SLDSDataTableRow';
export var DATE_PICKER = 'SLDSDatePicker';
export var DEPRECATED_WARNING = 'SLDSDeprecatedWarning';
export var DYNAMIC_ICON = 'SLDSDynamicIcon';
export var DIALOG = 'SLDSDialog';
export var FILES = 'SLDSFiles';
export var FILES_FILE = "SLDSFilesFile";
export var FILES_MORE = "SLDSFilesMore";
export var FILES_FIGURE = 'SLDSFilesFigure';
export var FILES_ACTIONS = 'SLDSFilesActions';
export var EXPANDABLE_SECTION = 'SLDSExpandableSection';
export var EXPRESSION = 'SLDSExpression';
export var EXPRESSION_GROUP = 'SLDSExpressionGroup';
export var EXPRESSION_CONDITION = 'SLDSExpressionCondition';
export var EXPRESSION_FORMULA = 'SLDSExpressionFormula';
export var FILTER = 'SLDSFilter';
export var CHECKBOX = 'SLDSCheckbox';
export var FORMS_INLINE_EDIT = 'SLDSInlineEdit';
export var INPUT = 'SLDSInput';
export var TEXTAREA = 'SLDSTextarea';
export var SEARCH = 'SLDSSearch';
export var GLOBAL_HEADER = 'SLDSGlobalHeader';
export var GLOBAL_HEADER_BUTTON = 'SLDSGlobalHeaderButton';
export var GLOBAL_HEADER_DROPDOWN = 'SLDSGlobalHeaderDropdown';
export var GLOBAL_HEADER_FAVORITES = 'SLDSGlobalHeaderFavorites';
export var GLOBAL_HEADER_HELP = 'SLDSGlobalHeaderHelp';
export var GLOBAL_HEADER_NOTIFICATIONS = 'SLDSGlobalHeaderNotifications';
export var GLOBAL_HEADER_PROFILE = 'SLDSGlobalHeaderProfile';
export var GLOBAL_HEADER_SEARCH = 'SLDSGlobalHeaderSearch';
export var GLOBAL_HEADER_SETUP = 'SLDSGlobalHeaderSetup';
export var GLOBAL_HEADER_TASK = 'SLDSGlobalHeaderTask';
export var GLOBAL_HEADER_TOOL = 'SLDSGlobalHeaderTool';
export var GLOBAL_NAVIGATION_BAR = 'SLDSGlobalNavigationBar';
export var GLOBAL_NAVIGATION_BAR_BUTTON = 'SLDSGlobalNavigationBarButton';
export var GLOBAL_NAVIGATION_BAR_DROPDOWN = 'SLDSGlobalNavigationBarDropdown';
export var GLOBAL_NAVIGATION_BAR_LABEL = 'SLDSGlobalNavigationBarLabel';
export var GLOBAL_NAVIGATION_BAR_LINK = 'SLDSGlobalNavigationBarLink';
export var GLOBAL_NAVIGATION_BAR_REGION = 'SLDSGlobalNavigationBarRegion';
export var GLOBAL_NAVIGATION_BAR_APP_LAUNCHER = 'SLDSGlobalNavigationBarAppLauncher';
export var GRID = 'SLDSGrid';
export var HIGHLIGHTER = 'SLDSHighlighter';
export var ICON = 'SLDSIcon';
export var ICON_SETTINGS = 'SLDSIconSettings';
export var ICON_INPUT = 'SLDSIconInput';
export var ILLUSTRATION = 'SLDSIllustration';
export var LIST = 'SLDSList';
export var LIST_ITEM = 'SLDSListItem';
export var LIST_ITEM_LABEL = 'SLDSListItemLabel';
export var LISTBOX_OF_PILL_OPTIONS = 'SLDSListboxOfPillOptions';
export var LOCATION_MAP = 'SLDSLocationMap';
export var LOOKUP = 'SLDSLookup';
export var MEDIA_OBJECT = 'SLDSMediaObject';
export var MENU_DROPDOWN = 'SLDSMenuDropdown';
export var MENU_DROPDOWN_TRIGGER = 'SLDSMenuDropdownTrigger';
export var MENU_PICKLIST = 'SLDSMenuPicklist';
export var MODAL = 'SLDSModal';
export var NOTIFICATION = 'SLDSNotification';
export var PANEL = 'SLDSPanel';
export var PANEL_FILTER_GROUP = 'SLDSFilterGroup';
export var PANEL_FILTER_LIST = 'SLDSFilterList';
export var PANEL_FILTER_LIST_HEADING = 'SLDSPanelFilterListHeading';
export var PAGE_HEADER = 'SLDSPageHeader';
export var PAGE_HEADER_CONTROL = 'SLDSPageHeaderControl';
export var PILL = 'SLDSPill';
export var PILL_CONTAINER = 'SLDSPillContainer';
export var PORTAL_SETTINGS = 'SLDSPortalSettings';
export var POPOVER = 'SLDSPopover';
export var POPOVER_EDIT_DIALOG = 'SLDSPopoverEditDialog';
export var POPOVER_TOOLTIP = 'SLDSPopoverTooltip';
export var PROGRESS_INDICATOR = 'SLDSProgressIndicator';
export var PROGRESS_INDICATOR_PROGRESS = 'SLDSProgressIndicatorProgress';
export var PROGRESS_INDICATOR_STEP = 'SLDSProgressIndicatorStep';
export var PROGRESS_INDICATOR_STEP_VERTICAL = 'SLDSProgressIndicatorStepVertical';
export var PROGRESS_RING = 'SLDSProgressRing';
export var PROGRESS_BAR = 'SLDSProgressBar';
export var SETUP_ASSISTANT = 'SLDSSetupAssistant';
export var SETUP_ASSISTANT_STEP = 'SLDSSetupAssistantStep';
export var SCOPED_NOTIFICATION = 'SLDSScopedNotification';
export var SLIDER = 'SLDSSlider';
export var SPINNER = 'SLDSSpinner';
export var SPLIT_VIEW = 'SLDSSplitView';
export var SPLIT_VIEW_HEADER = 'SLDSSplitViewHeader';
export var SPLIT_VIEW_LISTBOX = 'SLDSSplitViewListbox';
export var RADIO = 'SLDSRadio';
export var RADIO_GROUP = 'SLDSRadioGroup';
export var RADIO_BUTTON_GROUP = 'SLDSRadioButtonGroup';
export var TAB = 'SLDSTab';
export var TAB_ITEM = 'SLDSTabItem';
export var TAB_PANEL = 'SLDSTabPanel';
export var TABS = 'SLDSTabs';
export var TABS_LIST = 'SLDSTabsList';
export var TABS_PANEL = 'SLDSTabsPanel';
export var TIME_PICKER = 'SLDSTimepicker';
export var TOAST = 'SLDSToast';
export var TOAST_CONTAINER = 'SLDSToastContainer';
export var TREE = 'SLDSTree';
export var TREE_BRANCH = 'SLDSTreeBranch';
export var TREE_ITEM = 'SLDSTreeItem';
export var TRIAL_BAR = 'SLDSTrialBar';
export var TRIAL_BAR_DROPDOWN = 'SLDSTrialBarDropdown';
export var TRIAL_BAR_BUTTON = 'SLDSTrialBarButton';
export var VERTICAL_NAVIGATION = 'SLDSVerticalNavigation';
export var VERTICAL_NAVIGATION_ITEM = 'SLDSVerticalNavigationItem';
export var VISUAL_PICKER = 'SLDSVisualPicker';
export var VISUAL_PICKER_LINK = 'SLDSVisualPickerLink';
export var WELCOME_MAT = 'SLDSWelcomeMat';
export var WELCOME_MAT_TILE = 'SLDSWelcomeMatTile';
export var WELCOME_MAT_BADGE = 'SLDSWelcomeMatBadge';
//# sourceMappingURL=constants.js.map